import { render } from "./BackgroundRain.vue?vue&type=template&id=95d86066&scoped=true"
import script from "./BackgroundRain.vue?vue&type=script&lang=js"
export * from "./BackgroundRain.vue?vue&type=script&lang=js"

import "./BackgroundRain.vue?vue&type=style&index=0&id=95d86066&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95d86066"

export default script